import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

export const useCountryFromCitiesInfo = (countrySlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const { getCountryFromCitiesInfo } = useExperienceApi();

  const { data: countryFromCitiesInfo } = useQuery({
    queryKey: ['useCountryFromCitiesInfo', countrySlug],
    queryFn: async () => await getCountryFromCitiesInfo({ path: { countrySlug: unref(countrySlug) as string } }),
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    countryFromCitiesInfo,
  };
};
